export default __webpack_public_path__ + "static/media/ledp-ict.830c8278.png";